var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.222,
    height: 19.22,
    viewBox: "0 0 19.222 19.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fdfdfd;stroke:#fdfdfd;}.a{stroke-width:0.3px;}.b{stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.296 -0.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.965.5,16.009,2.457l-.883-.883A2.254,2.254,0,0,0,13.318.921l-3.148.285a2.284,2.284,0,0,0-1.395.652L.662,9.971a2.267,2.267,0,0,0,0,3.2l5.272,5.272a2.274,2.274,0,0,0,3.207,0l8.108-8.112A2.246,2.246,0,0,0,17.9,8.939l.285-3.148a2.27,2.27,0,0,0-.652-1.807L16.652,3.1l1.957-1.957A.455.455,0,0,0,17.965.5ZM16.9,4.622A1.356,1.356,0,0,1,17.29,5.7l-.285,3.148a1.348,1.348,0,0,1-.394.838L8.494,17.807a1.359,1.359,0,0,1-1.92,0L1.3,12.535a1.359,1.359,0,0,1,0-1.92L9.413,2.5a1.372,1.372,0,0,1,.838-.394L13.4,1.818a1.129,1.129,0,0,1,.122,0,1.355,1.355,0,0,1,.96.4l.883.883L13.789,4.672a1.895,1.895,0,1,0,.639.643L16,3.739ZM13.513,6.986a.983.983,0,1,1-.086-1.463.336.336,0,0,0,.072.091.7.7,0,0,0,.091.073A.978.978,0,0,1,13.513,6.986Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.276,187.593a.452.452,0,1,0-.639.639l3.587,3.587a.445.445,0,0,0,.322.131.464.464,0,0,0,.322-.131.451.451,0,0,0,0-.639Zm0,0",
    transform: "translate(-121.73 -178.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M92.975,222.891a.452.452,0,1,0-.639.639l3.587,3.587a.444.444,0,0,0,.322.131.463.463,0,0,0,.321-.131.451.451,0,0,0,0-.639Zm0,0",
    transform: "translate(-88.028 -212.317)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.4e31748c851faef9164da11a5887493d.svg";
export { ForwardRef as ReactComponent };